<template>
  <el-card>

    <el-row>
      <el-col :span="18">&nbsp;</el-col>
      <el-col :span="6">
        <el-button v-if="showAdd" type="primary" @click="addCollectAccount">
          添加收款账户
        </el-button>
        <!-- <el-button type="primary" @click="goBack">
          返回
        </el-button> -->
      </el-col>
    </el-row>

    <el-row>
      <el-col>

        <el-table :data="list">
          <el-table-column prop="id" label="id">
            <template slot-scope="scope" >
              {{scope.row.id}}
            </template>
          </el-table-column>

          <el-table-column prop="account" label="账户"></el-table-column>

          <el-table-column prop="remark" label="备注"></el-table-column>
          
          <el-table-column prop="create_time" label="创建日期">
            <template slot-scope="scope">
              <span>{{scope.row.create_time | parseTime('{y}-{m}-{d}')}}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip v-if="showView" content="查看" placement="top-start" effect="light">
                <el-button type="text" @click="viewCollectAccount(scope.row.id)">
                  <i class="el-icon-view"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip v-if="showEdit" content="编辑" placement="top-start" effect="light">
                <el-button type="text" @click="editCollectAccount(scope.row.id)">
                  <i class="el-icon-edit"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip v-if="showDelete" content="删除" placement="top-start" effect="light">
                <el-button type="text" @click="deleteCollectAccount(scope.row.id)">
                  <i class="el-icon-delete"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { fetchSettingCollectAccountList } from '@/api/billing'
import { deleteSettingCollectAccount } from '@/api/billing'
import { parseTime } from '@/utils'
export default {
  name: 'setting-collect-account-list',
  data() {
    return {
      showView: false,
      showAdd: false,
      showEdit: false,
      showDelete: false,
      query: {
        offset: 0,
        limit: 20
      },
      loading: false,
      list: []
    }
  },
  methods:{
    addCollectAccount: function(){
      this.$router.push({name: 'addSettingCollectAccount'})
    },
    viewCollectAccount: function(id){
      console.log('viewCollectAccount: ' + id)
      this.$router.push({name: 'viewSettingCollectAccount', query: {id:id}})
    },
    editCollectAccount: function(id){
      this.$router.push({name: 'editSettingCollectAccount', query: {id:id}})
    },
    deleteCollectAccount: function(id){
      console.log('deleteCollectAccount(): id=' + id )
      deleteSettingCollectAccount(id)
        .then(resp=>{
          setTimeout(()=>{
            this.$message.success('成功删除收款账户信息')
            this.getList()
          }, 500)
        }).catch(err=>{
          this.$$error_message('err')
        })
    },
    goBack: function(){
      this.$router.go(-1)
    },
    getList: function(){
      this.loading = true
      fetchSettingCollectAccountList(this.query)
        .then( resp => {
          this.list = resp.results
          this.loading = false
        }).catch( err => {
          this.loading = false
          this.$error_message(err)
        })
    }
  },
  created(){
    // console.log('company_id: ' + this.$route.query.company_id)
    // if(this.$route.query.company_id === undefined || this.$route.query.company_id === null){
    //   this.$router.push('/404')
    // }
    // this.company_id = this.$route.query.company_id

    // 权限检查
    if (!this.$perm(["billing.list_setting_collect_account"])) {
      this.$router.push('/401')
    }
    this.showView = true

    if (this.$perm(["billing.create_setting_collect_account"])) {
      this.showAdd = true
    }
    if (this.$perm(["billing.update_setting_collect_account"])) {
      this.showEdit = true
    }
    if (this.$perm(["billing.delete_setting_collect_account"])) {
      this.showDelete = true
    }

    this.getList()
  }
}
</script>